function checkPath(location) {
  // Never suppress the chrome on the New Era shell. `checkPath` computes
  // `noNavBar`, and `/connect/*` is nav_v3 + connect_frontend, where nav_v3
  // OWNS the header + drawer and must always render. A connect route like
  // `/connect/payment/requests` CONTAINS `/payment/`, which would otherwise
  // match below and hide nav_v3's whole `<v-app v-if="!noNavBar">`. The
  // substrings below are LEGACY full-bleed routes; they must not match a
  // `/connect/*` path. Same guard as `isActivePublicMicrofrontend`.
  if (location.includes("/connect/")) return false;
  let flag = false;
  const paths = [
    "/payment/",
    "/pos",
    "/catalogue",
    "/events",
    "/checkout",
    "/spf",
    "/property-maintenance",
    "/terms",
    "/inv-agg",
  ];
  flag = paths.some((url) => location.includes(url));

  if (location.includes("transaction") || location.includes("table-header")) {
    flag = false;
  }

  return flag;
}

function isActivePublicMicrofrontend(location) {
  // Never on the New Era shell. `/connect/*` is connect_frontend + nav_v3, and a
  // connect route like `/connect/payment/requests` CONTAINS `/payment/`, which
  // would otherwise match below and mount the public-pages MFE on top of the
  // facelift. Every other design's activeWhen already AND-excludes `/connect/`
  // (see the legacy `navigation` predicate); this one has to as well.
  if (location.pathname.includes("/connect/")) return false;
  return (
    (location.pathname.includes("/checkout") &&
      !location.pathname.includes("/catalogue")) ||
    location.pathname.includes("/pos/attempt-detail") ||
    location.pathname.includes("/payment/") ||
    location.pathname.includes("/property-maintenance") ||
    location.pathname.includes("/terms") ||
    location.pathname.includes("/inv-agg")
  );
}

function checkSentryErrors(event, hint) {
  const { response } = hint.originalException;
  if (
    response &&
    response.status &&
    response.status >= 400 &&
    response.status < 500
  ) {
    return null;
  }
  return event;
}

function renderMountErrorMessage() {
  document.body.style.display = "flex";
  document.body.style.justifyContent = "center";
  document.body.style.alignItems = "center";
  document.body.style.height = "100vh";
  document.body.style.margin = "0";

  const div = document.createElement("div");
  div.textContent =
    "Please check your internet connection and refresh the page";
  div.style.fontSize = "24px";
  div.style.fontFamily = "Arial, sans-serif";
  document.body.appendChild(div);
}

export {
  checkPath,
  checkSentryErrors,
  renderMountErrorMessage,
  isActivePublicMicrofrontend,
};
